<script lang="ts">
	import { setCookie } from "@utils/setCookie.js";
	import { Currency } from "@core/schema/Currency.js";
	import { currencyNameMap } from "@core/schema/names/currencyNameMap.js";
	import { getCurrencySymbol } from "@core/utils/formatPrice.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";
	import { currencyCookieName } from "../../currencyCookieName.js";
	import { selectedCurrency } from "../../state/selectedCurrency.svelte.js";

	const { tenant } = getGlobalTemplateProps();
</script>

<div class="flex flex-col gap-4 size-fit">
	{#each Object.values(Currency).filter((currency) => currency !== selectedCurrency.current) as targetCurrency (targetCurrency)}
		<button
			class={[
				"size-16 border-white/16 hover:border-white transition-colors",
				"flex justify-center items-center rounded-full border",
			]}
			title={currencyNameMap[targetCurrency][tenant.locale]}
			onclick={async (): Promise<void> => {
				await setCookie(currencyCookieName, targetCurrency);
				location.reload();
			}}
		>
			<span class="text-white text-sm/4 font-medium">{getCurrencySymbol(targetCurrency, tenant.locale)}</span>
		</button>
	{/each}
</div>
